import { useNavigate, useParams, useLocation } from "react-router-dom";
import heading from "../assets/images/home_page_images/heading.svg";
import dashedArrow from "../assets/images/home_page_images/dashedArrow.svg";
import useFunctionsCount from "../hooks/useFunctionsCount";
import functionTypes from "../utils/constants/functionTypes";
import showToast from "../helpers/showToast";
import { subscribedPackage } from "../utils/store";
import { useAtom } from "jotai";
import { useState } from "react";
import FunctionsLimitModal from "./Modals/FunctionsLimitModal";
import { Button, Card } from "react-bootstrap";
import { BsStars } from "react-icons/bs";

const EmptyListingBanner = ({
  headLineText,
  title,
  onClick,
  link,
  showAdd = true,
  type = null,
  getData,
  dynamicQRCodeId,
  onAiCreateClick,
}) => {
  const {
    compareLimits,
    updateCount,
    limitExceededForStarter,
    compareLimitsForDynamicQR,
  } = useFunctionsCount();
  const [showModal, setShowModal] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const navigate = useNavigate();
  const { teamId, userId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");

  // const handleClick = (link) => {
  //   const res = handleShowCustomUrlModal(type);
  //   if (res)
  //     return showToast(
  //       false,
  //       "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
  //     );
  //   navigate(link);
  // };

  const handleClick = async (link) => {
    if (dynamicQRCodeId) {
      const res = handleShowCustomUrlModal(type);
      if (res)
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      navigate(link);
    } else if (purchasedPackage.id === 1) {
      limitExceededForStarter()
        .then((isLimitExceeded) => {
          if (isLimitExceeded) {
            setShowModal(true);
          } else {
            navigate(link);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
      return;
    } else {
      const res = handleShowCustomUrlModal(type);
      if (res)
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      navigate(link);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowCustomUrlModal = (type) => {
    if (type == "card") {
      if (dynamicQRCodeId !== null) {
        return compareLimitsForDynamicQR(functionTypes.CARD, dynamicQRCodeId);
      } else {
        return compareLimits(functionTypes.CARD);
      }
    }

    return false;
  };

  return (
    <>
      <Card className="infoWrapper">
        <Card.Body>
          <div className="contentWrapper">
            <img src={heading} alt="" />
            <div>
              <div class="card-title h5 mb-2 mt-4">Tips</div>
              <p className="mb-4">
                {`You haven't created any ${headLineText} yet, in order to get started click the "${title}"  button below`}
              </p>
              {showAdd ? (
                <div className="arrowImgWrapper">
                  {/* <div className="arrowImg">
                    <img src={dashedArrow} alt="" />
                  </div> */}

                  <div className="createBtnWrapper mobileViewWrapper" style={{ display: 'flex', gap: '12px', justifyContent: 'flex-start' }}>
                    {link ? (
                      <Button
                        variant="primary"
                        onClick={() => handleClick(link)}
                      >
                        {title}
                      </Button>
                    ) : (
                      <Button variant="primary" onClick={onClick}>
                        {title}
                      </Button>
                    )}
                    {/* {onAiCreateClick && (
                      <Button onClick={onAiCreateClick} className="ai-create-btn d-inline-flex align-items-center gap-2">
                        <BsStars /> Create with AI
                      </Button>
                    )} */}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </Card.Body>
      </Card>

      <FunctionsLimitModal
        show={showModal}
        handleClose={handleCloseModal}
        getData={getData}
      />
    </>
  );
};

export default EmptyListingBanner;
